import { createContext } from 'react'
import type { UseModalType } from '../hooks/useModal'

export const ModalContext = createContext<UseModalType>(undefined as unknown as UseModalType)
